var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 33C60.5523 33 61 32.5523 61 32C61 31.4477 60.5523 31 60 31V33ZM20 33H60V31H20V33Z",
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49C60.5523 49 61 48.5523 61 48C61 47.4477 60.5523 47 60 47V49ZM20 49H60V47H20V49Z",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenu);
export default __webpack_public_path__ + "static/media/NavMenu.bf7b238d60a5188ce9e79ea899eba6b9.svg";
export { ForwardRef as ReactComponent };